import * as form from '../form';

export const identificationSSN = (data = {}) => ({
  ssn: form.ssn(data.ssn),
  verified: data.verified || false,
  SSNNAExplanation: form.textarea(data.SSNNAExplanation), // PVQ only
});
